import Vue from 'vue';
import axios from 'axios'

//Vue.prototype.$moment = moment;
Vue.config.productionTip = false;

// Mise en place d'axios
axios.defaults.baseURL = process.env.VUE_APP_BASE_API_URL;
Vue.prototype.$http = axios;
//Vue.use(require('vue-moment'));
Vue.prototype.$storeConcours = {
    ReadOnly:true,
    DonneesFormulaire: {
        AfficherMessage:true,
        EtatDossier:null,
        Programmes: [],
        PpId: null,
        CandidatureId: null,
        ListeConcours: [],
        EcoleRetenue: null,
    },
    RazDonneesFormulaire() {
        this.ReadOnly = true;
        this.DonneesFormulaire.EtatDossier=null;
        this.DonneesFormulaire.AfficherMessage=true;
        this.DonneesFormulaire.Programmes = [];
        this.DonneesFormulaire.PpId = null;
        this.DonneesFormulaire.CandidatureId = null;
        this.DonneesFormulaire.ListeConcours = [];
        this.DonneesFormulaire.EcoleRetenue = null;
    },
    GetListeConcours(token) {
        return axios.create({
            baseURL: process.env.VUE_APP_BASE_API_URL,
            withCredentials: false,
            headers: {
                Accept: 'application/json',
                token: token
            }
        })
            .get("concours/GetListeConcours")
    },
    EnregistrerConcours(token) {
        return axios.create({
            baseURL: process.env.VUE_APP_BASE_API_URL,
            withCredentials: false,
            headers: {
                Accept: 'application/json',
                token: token
            }
        })
            .post("concours/EnregistrerConcours", this.DonneesFormulaire);
    },
    MapperDto(dto) {
        if (dto) {
            this.RazDonneesFormulaire();
            this.DonneesFormulaire.AfficherMessage = dto.afficherMessage;
            this.DonneesFormulaire.Ppid = dto.PpId;
            this.DonneesFormulaire.CandidatureId = dto.candidatureId;
            this.DonneesFormulaire.Programmes = dto.programmes;
            this.DonneesFormulaire.EcoleRetenue = dto.ecoleRetenue;
            this.DonneesFormulaire.EtatDossier = dto.etatDossier;
            dto.listeConcours.forEach(element => {
                var concours = {
                    Supprimer: false,
                    IdCrypte: element.idCrypte,
                    ConcoursFrancais: element.concoursFrancais,
                    ConcoursMarocain: element.concoursMarocain,
                    EcoleFrancaise: element.ecoleFrancaise,
                    EcoleMarocaine: element.ecoleMarocaine,
                    AdmisEcrit: element.admisEcrit,
                    AdmisOral: element.admisOral,
                }

                if (concours.ConcoursFrancais) {
                    concours.FrancaisOuMarocain = 1;
                }
                else {
                    concours.FrancaisOuMarocain = 2;
                }

                this.DonneesFormulaire.ListeConcours.push(concours);
            });
        }
    }
}